'use client';
import style from './style.module.css';
import Image from 'next/image';
import sentiment_dissatisfied from '@/img/sentiment_dissatisfied.svg';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';

const NotFound = () => {
  const t = useTranslations('Index');
  return (
    <div className={style.wrapperNotFound}>
      <div className={style.containerNotFound}>
        <div className={style.errorMessageNotFound}>
          <h2 className={style.contentNotFound__title}>404</h2>
          <Image
            className={style.errorNotFoundImage}
            src={sentiment_dissatisfied}
            alt="Error Icon Emote"
          />
        </div>

        <div className={style.containerInfoNotFound}>
          <div className={style.contentNotFound__subtitle}>
            <h4>{t('notFound.title')}</h4>
          </div>
          <div className={style.contentNotFound__paragraph}>
            <p>{t('notFound.subtitle')}</p>
          </div>
        </div>
        <Link href={`/` as any}>
          <button
            aria-label="Return to home page"
            className={style.buttonNotFound}>
            {t('notFound.buttonHome')}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
